import Header from '@components/Header';

function OrderHeader() {
  return (
        <Header title='주문내역'/>
  );
}

export default OrderHeader;
